export const AUTO_HIDE_DURATION = 3000;

export const INTERNAL_SERVER_ERROR =
  "Something went wrong! Please try again later.";

export const COPY_ERROR = "Failed to copy text";

export enum Notifications {
  INTERNAL_SERVER_ERROR = "Something went wrong! Please try again later.",
  COPY_ERROR = "Failed to copy text",
  PA_UPDATE_ERROR = "Cannot save updates! Please try again later.",
  ASIN_IS_NOT_10_CHARS = "ASIN should be 10 characters.",
  ASIN_IS_NOT_ALPHANUMERIC = "ASIN should consist of alphanumeric characters.",
  MISC_FEE_PERCENT_BETWEEN_ZERO_TO_HUNDRED = "Misc fee percent should be between from 0 to 100.",
  ASIN_NOT_FOUND = "Cannot find a product. Please try different ASIN.",
}

export const FILE_DELETE_SUCCESS = "File deleted successfully";
export const FILE_DELETE_FAILURE =
  "Failed to delete file. Please try again later.";
export const LOAD_FILES_FAILURE =
  "Failed to load files. Please try again later.";
export const AMAZON_CREDENTIALS_NOT_ADDED = "Amazon credentials are missing.";
export const LOAD_STATS_FAILURE = "Failed to load statistics";
export const FILE_SUCCESSFULLY_EXPORTED = "File exported successfully";
export const FILE_EXPORTED_FAILURE = "Failed to export file";
export const FILE_UPLOAD_FAILURE =
  "Failed to upload file. Please try again later.";
export const FILE_IS_EMPTY = "File is empty";
export const FILE_UPLOAD_SUCCESS = "File uploaded successfully";
export const UPLOAD_PLAN_LIMIT_EXCEEDED =
  "You have exceeded your current plan limit. Please upgrade your plan to continue using this feature.";

export const REGISTRATION_FAILED =
  "Registration failed. Please try again later.";
export const GOOGLE_AUTH_FAILED =
  "Google authentication failed. Please try again later.";
export const EMAIL_ALREADY_EXISTS =
  "Email address already exists. Please use a different email.";
export const USER_NOT_EXIST =
  "User with this email does not exist. Please register first.";
export const RESET_PASSWORD_FAILED =
  "Failed to reset password. Please try again later.";
export const RECAPTCHA_REQUIRED = "Please complete the reCAPTCHA";
export const WRONG_AUTH_CREDENTIALS =
  "Incorrect email or password. Check your credentials and try again.";
export const NEW_PASSWORD_SET_FAILED =
  "Failed to set new password. Please try again later.";
export const NEW_PASSWORD_TOKEN_EXPIRED =
  "You have already set a new password. Please login or reset your password again.";
export const RESEND_VERIFICATION_EMAIL_FAILED =
  "Failed to resend verification email. Please try again later.";
export const EMAIL_NOT_VERIFIED = "Email is not verified.";
export const RESEND_VERIFICATION_EMAIL_SUCCEEDED =
  "Verification email sent successfully.";

export const WRONG_OLD_PASSWORD = "Wrong old password.";
export const PASSWORD_CHANGED_SUCCESSFULLY = "Password changed successfully.";
export const UNABLE_TO_CHANGE_PASSWORD =
  "Unable to change password. Please try again later.";

export const FAILED_TO_CHANGE_PROFILE_INFO =
  "Failed to change profile information. Please try again later.";
export const FAILED_TO_UPLOAD_AVATAR = "Failed to upload avatar.";
export const MAX_FILE_SIZE_EXCEEDED =
  "The file size exceeds the maximum limit. Please upload a smaller file.";

export const NO_SEARCH_RESULTS =
  "No products found. Check the spelling, try different keywords, ASIN, UPC or ISBN code.";
export const PLAN_LIMIT_EXCEEDED_ERR = "Plan limit exceeded";

export const MIN_BSR_VALIDATION_ERROR =
  "Min BSR must be less than equal to Max BSR.";
export const MAX_BSR_VALIDATION_ERROR =
  "Max BSR must be less than equal to Min BSR.";
